<app-lms-modal-frame [title]="'Submenu Details'" [pageHeadWidth]="600">
  <div modal-body>
    <form [formGroup]="submenuForm">
      <table class="table table-striped table-light table-hover table-sm mb-3 caption-top w-100">
        <tbody class="field-4column-label">
          <tr>
            <td>Submenu</td>
            <td>
              <input formControlName="submenu" [(ngModel)]="submenuModel.submenu" required>
              <div *ngIf="submenuForm.controls.submenu.errors?.required && submitted" class="error-label">
                Submenu is required.
              </div>
            </td>
          </tr>
          <tr>
            <td>Component</td>
            <td>
              <input formControlName="component" [(ngModel)]="submenuModel.component" required>
              <div *ngIf="submenuForm.controls.component.errors?.required && submitted" class="error-label">
                Component is required.
              </div>

            </td>
          </tr>
          <tr>
            <td><label for="selectedRole">Role</label></td>
            <td>
              <mdb-select style="width: 99%" formControlName="userRoles" multiple required
                [(ngModel)]="submenuModel.userRoles">
                <mdb-option *ngFor="let title of jobTitles" [value]="title">{{title.jobTitle}}</mdb-option>
              </mdb-select>

              <div *ngIf="submenuForm.controls.userRoles.errors?.required && submitted" class="error-label">
                Job title is required.
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </form>
  </div>

  <div modal-actions class="lms-action-bar">
    <button class="btn btn-primary me-1" mdbRipple (click)="close()">Cancel</button>
    <button class="btn btn-primary" mdbRipple (click)="saveChanges(submenuModel)">Add/Update Submenu</button>
  </div>
</app-lms-modal-frame>
